<template>
  <div :style="themeStyle">
    <v-container class="pt-10">

        <v-dialog v-model="loading" persistent width="300">
          <v-card color="primary" dark>
            <v-card-text>
              <v-progress-linear
                indeterminate
                color="white"
                class="mb-0 btn_icon1"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>

       <v-dialog
          v-model="failed"
          persistent
        >
          <v-card class="pa-7">
            <v-row>
              <v-col class="text-center"><v-img src="/static/img/oops.svg" /></v-col>
            </v-row>
            <v-row>
              <v-col class="text-center pt-0"><span class="headline2 font18" v-html="message"></span></v-col>
            </v-row>
            <v-row>
              <v-col class="text-center">
                <v-btn
                  rounded
                  class="btn_icon1"
                  dark
                  @click="$router.push('home')"
                >
                  ดูคะแนนสะสม และ ของรางวัล
                </v-btn>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="success"
          persistent
        >
          <v-card class="pa-7">
            <v-row>
              <v-col class="text-center"><div style="height: 250px; width: 250px;margin-left: 10px"><img style="max-width: 100%; max-height: 100%;" :src="detailPackage.packageImg"/></div></v-col>
            </v-row>
            <v-row>
              <v-col class="text-center pb-0"><span class="headline1 font28 weight1000">คุณได้รับแพ็กเกจ</span></v-col>
            </v-row>
            <v-row>
              <v-col class="text-center pa-0"><span class="headline1 font55 weight1000">{{detailPackage.packageName}}</span></v-col>
            </v-row>
            <v-row>
              <v-col class="text-center pt-0"><span class="headline1 font23 weight1000">*สามารถใช้เเพคเกจนี้ใช้ได้ ทั้งหมด {{detailPackage.packageCount}} ครั้ง</span></v-col>
            </v-row>
            <v-row>
              <v-col class="text-center">
                <v-btn
                  rounded
                  class="btn_icon1"
                  dark
                  @click="$router.push('MyPackage')"
                >
                  ดูแพ็กเกจทั้งหมด
                </v-btn>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-bottom-sheet v-if="levelUpdate"
          v-model="levelup"
          persistent
          hide-on-scroll
          overlay-opacity="1"
        >
          <v-sheet
            class="text-center"
            height="75vh"
          >
            <v-img src="/static/img/papershoot.png" style="position:absolute;top:0;" />
            <v-img src="/static/img/golden.png" max-width="300" max-height="392" style="position:absolute;top:60px;left:35px;" />
            <v-row style="padding-top:240px;">
              <v-col class="text-center pb-0"><span class="headline1 font55 bold">Congrats!</span></v-col>
            </v-row>
            <v-row>
              <v-col class="text-center pb-0"><span class="headline2 font18 bold">คุณได้รับคะแนนเพิ่ม</span></v-col>
            </v-row>
            <v-row v-if="point">
              <v-col class="text-center pa-0"><span class="headline2 font24 weight1000">{{point}}</span></v-col>
            </v-row>
            <v-row>
              <v-col class="text-center pt-0"><span class="headline2 font18 bold">คะแนน</span></v-col>
            </v-row>
            <v-row>
              <v-col class="text-center pt-0 pb-0"><span class="headline1 font24 bold">และได้อัพเกรดเป็นสมาชิก</span></v-col>
            </v-row>
            <v-row>
              <v-col class="text-center pt-0 pb-3"><span class="headline1 font28 weight1000">{{levelUpdate.name}}</span></v-col>
            </v-row>
            <v-row>
              <v-col class="ml-5 mr-5 text-center">
                <v-btn
                  rounded
                  class="btn_icon1"
                  dark
                  @click="$router.push('privilege')"
                >
                  ดูสิทธิประโยชน์ที่ได้รับเพื่มเติม
                </v-btn>
              </v-col>
            </v-row>
          </v-sheet>
        </v-bottom-sheet>

    </v-container>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Swal from 'sweetalert2'
import axios from 'axios'
export default {
  name: 'PointCollect',
  data () {
    return {
      loading: true,
      success: false,
      levelup: false,
      failed: false,
      packageToken: null,
      point: null,
      message: null,
      level: null,
      member: null,
      levelUpdate: null,
      findUser: null,
      profile: [],
      detailPackage: null
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted () {
    this.packageToken = this.$route.query.packageToken

    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    if (this.member === null) {
      this.findUser = false
    } else {
      this.findUser = true
    }
    if (this.packageToken === '') {
      this.message = 'รหัสรับเเพ็คเกจไม่ถูกต้อง<br>กรุณาติดต่อเจ้าหน้าที่ค่ะ'
      this.success = false
      this.levelup = false
      this.loading = false
      this.failed = true
    } else if (this.findUser) {
      await this.collectPackage()
    } else if (!this.findUser) {
      await axios.get(this.DNS_IP + '/packageQRcode/get?shopId=' + this.$route.query.shopId + '&token=' + this.packageToken).then(async result => {
        if (result.data.status === undefined) {
          if (result.data[0].status === 'waiting') {
            Swal.fire({
              title: '<h2>ต้องการสมัครสมาชิก ใช่หรือไม่?</h2>',
              showCancelButton: true,
              allowOutsideClick: false,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#b3b1ab',
              confirmButtonText: 'สมัครสมาชิก',
              cancelButtonText: 'ยกเลิก'
            }).then(async (confirm) => {
              if (confirm.isConfirmed) {
                this.$router.push(`/RegisterMember?shopId=${this.$route.query.shopId}&packageToken=${this.$route.query.packageToken}`)
              } else {
                this.$router.push('/bankPage')
              }
            })
          } else {
            this.success = false
            this.levelup = false
            this.failed = true
            this.message = 'ขออภัย!<br>Qr code นี้ถูกใช้ไปแล้ว'
          }
        } else {
          this.message = 'รหัสรับคะแนนไม่ถูกต้อง<br>กรุณาติดต่อเจ้าหน้าที่ครับ'
          this.success = false
          this.levelup = false
          this.failed = true
        }
      })
    }
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),

    async getLevelDB () {
      const result = await this.callBeTaskAPI('get', '/level/line/get?RECORD_STATUS=N')
      if (result) {
        if (result.length > 0) {
          this.setLevel(result)
          return result
        }
      }
    },
    async collectPackage () {
      // get package by token
      const resultPackage = await this.callBeTaskAPI('get', `/packageQRcode/get?shopId=${this.$route.query.shopId}&token=${this.packageToken}`)
      if (resultPackage) {
        this.detailPackage = resultPackage[0]
      }
      const params = {
        'token': this.packageToken
      }
      // get collect package
      const result = await this.callBeTaskAPI('post', `/collect_package/edit`, params)
      if (result) {
        if (result.status === true) {
          this.success = true
        } else if (result.status === false) {
          this.success = false
          this.levelup = false
          this.failed = true
          this.message = 'ขออภัย!<br>แพ็กเกจนี้ถูกใช้ไปแล้ว'
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/HomeCUSTOM/Package/CollecPackage.vue